/* eslint-disable */
import { library } from '@fortawesome/fontawesome-svg-core';

import {
  fas,
  faCheckCircle,
  faInfoCircle,
  faExclamationTriangle,
  faExclamationCircle,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  fas,
  faCheckCircle,
  faInfoCircle,
  faExclamationTriangle,
  faExclamationCircle,
);
